module.exports = __webpack_public_path__ + "img/pic_location_NewTaipeiCity.2e60306e.png";